import { Model } from './abstract-model';

class Commerce extends Model {
  name: string;
  img: string;
  owner: any;
  address: any;
}

export default Commerce;
